import { render } from "./TermsAndConditionsGlobal.vue?vue&type=template&id=6e68af62&scoped=true"
import script from "./TermsAndConditionsGlobal.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsGlobal.vue?vue&type=script&lang=js"

import "./TermsAndConditionsGlobal.vue?vue&type=style&index=0&id=6e68af62&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e68af62"]])

export default __exports__